/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Generátor UID pro plány obsahových úloh
 *
 * Plány jsou uloženy v iCalendar formátu, který vyžaduje, aby měla každá úloha
 * vlastní unikátní identifikátor.
 */
class ContentTaskPlanUidGenerator {
  /**
   * Vygeneruje pseudo-unikátní identifikátor iCalendar události.
   * Identifikátor je unikátní v rámci Player aplikace,
   * což by mělo požadavkům specifikace vyhovět.
   * @param {DsId} id
   * @returns {string}
   */
  generate(id) {
    return `ContentTaskPlan-${String(id)}`;
  }
}

export default ContentTaskPlanUidGenerator;
